"use client"

import { Layer } from "effect"
import { AppHttpClient } from "@/shared/scope"
import { RpcClient, RpcSerialization } from "@effect/rpc"
import { createEffectQueryNoAbort } from "@/lib/api/effect-query-utils"
import { FileExtractionsRpc } from "@/contexts/file-attachment"

const FileExtractionsRpcLive = RpcClient.layerProtocolHttp({ url: "/api/rpc/file-extractions" }).pipe(
  Layer.provide(AppHttpClient.layer),
  Layer.provideMerge(RpcSerialization.layerJson),
)

// NoAbort variant deliberately: the effect-query package's signal-passing
// runner has no timeout, so a hung/dead transport on first load left the
// feed image query pending forever (permanent skeleton, COV-289). The NoAbort
// util bounds every call at 30s so the query settles and TanStack's normal
// retry/refocus recovery applies.
export const feedMediaEq = createEffectQueryNoAbort(FileExtractionsRpcLive)
export { FileExtractionsRpc }
